import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Heart } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5Z2mmmU49Mvmjq9QJs21jD/Captura_de_pantalla_2026-05-15_a_las_17.15.09-removebg-preview.png';
export function Footer() {
  return <footer className="bg-cafe-card border-t border-cafe-border pt-16 pb-8 mt-auto" data-id="element-78">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-80">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-81">
            <Link to="/" className="inline-block mb-4" data-id="element-82">
              <img src={LOGO_URL} alt="Trastienda Café" className="h-20 w-auto object-contain" data-id="element-83" />
            </Link>
            <p className="text-cafe-text/80 max-w-sm mb-6" data-id="element-84">
              Tu café de barrio. Un ambiente acogedor donde disfrutar de crepes
              y batidos artesanos.
            </p>
            <div className="flex space-x-4" data-id="element-85">
              <a href="#" className="text-cafe-primary hover:text-cafe-accent transition-colors" aria-label="Instagram" data-id="element-86">
                <Instagram size={20} data-id="element-87" />
              </a>
              <a href="#" className="text-cafe-primary hover:text-cafe-accent transition-colors" aria-label="Facebook" data-id="element-88">
                <Facebook size={20} data-id="element-89" />
              </a>
            </div>
          </div>
          {/* Links */}
          <div data-id="element-90">
            <h4 className="font-serif text-lg font-semibold mb-4" data-id="element-91">Enlaces</h4>
            <ul className="space-y-3" data-id="element-92">
              <li data-id="element-93">
                <Link to="/" className="text-cafe-text/80 hover:text-cafe-accent transition-colors" data-id="element-94">
                  Inicio
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="/menu" className="text-cafe-text/80 hover:text-cafe-accent transition-colors" data-id="element-96">
                  Menú
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="/reservas" className="text-cafe-text/80 hover:text-cafe-accent transition-colors" data-id="element-98">
                  Reservas
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/sobre" className="text-cafe-text/80 hover:text-cafe-accent transition-colors" data-id="element-100">
                  Sobre Nosotros
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/contacto" className="text-cafe-text/80 hover:text-cafe-accent transition-colors" data-id="element-102">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
          {/* Cause */}
          <div data-id="element-103">
            <h4 className="font-serif text-lg font-semibold mb-4" data-id="element-104">
              Causa Solidaria
            </h4>
            <div className="bg-cafe-bg p-4 rounded-lg border border-cafe-border" data-id="element-105">
              <div className="flex items-center space-x-2 mb-2" data-id="element-106">
                <Heart size={16} className="text-cafe-accent" data-id="element-107" />
                <span className="font-medium text-sm" data-id="element-108">Apoyamos a FEEP</span>
              </div>
              <p className="text-xs text-cafe-text/80 mb-3" data-id="element-109">
                Colaboramos con la Fundación Española de Enfermedades Priónicas.
              </p>
              <Link to="/donaciones" className="text-xs font-medium text-cafe-accent hover:text-cafe-primary transition-colors underline underline-offset-2" data-id="element-110">
                Saber más y donar
              </Link>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-cafe-border flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-111">
          <p className="text-sm text-cafe-text/60" data-id="element-112">
            &copy; {new Date().getFullYear()} Trastienda Café. Todos los
            derechos reservados.
          </p>
          <div className="flex space-x-4 text-sm text-cafe-text/60" data-id="element-113">
            <a href="#" className="hover:text-cafe-primary" data-id="element-114">
              Aviso Legal
            </a>
            <a href="#" className="hover:text-cafe-primary" data-id="element-115">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}